import React from "react";
import pic from "../../assets/img/YP-logo.png";

const DeactiveLink = ({ lang }) => {
  return (
    <div
      className=" d-flex justify-content-center "
      style={{ height: "100vh" }}
    >
      <div
        className="d-flex justify-content-start flex-column align-items-center align-self-center  pt-4 "
        style={{ height: "50vh" }}
      >
        <img src={pic} width="180px" className="my-2" alt="." />
        <p className="my-3">
          <b>182.</b> Error
        </p>
        <p className="my-2" style={{ fontSize: "16px" }}>
          The link is currently inactive
        </p>
      </div>
    </div>
  );
};

export default DeactiveLink;
